// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"223":"commons","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"223":"e5e7cd87425996351a70","245":"b36c471d0376bd7a82a8","453":"619e0e8a679633e6b274"}[chunkId] + ".js";
};